import { Label, Layout, } from "@mcleod/components";

export abstract class AutogenLayoutAcceptCounterOffer extends Layout {
    labelStatus: Label;
}
